/**
 * Helpers de formatacao de data em pt-BR. Centraliza o uso de
 * ``toLocaleString`` que antes estava espalhado pelas telas.
 */

const DATE_OPTS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

const DATE_TIME_OPTS: Intl.DateTimeFormatOptions = {
  ...DATE_OPTS,
  hour: "2-digit",
  minute: "2-digit",
};

function parse(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Data curta: 29/05/2026 (vazio vira "—"). */
export function formatDate(value: string | Date | null | undefined): string {
  const d = parse(value);
  return d ? d.toLocaleDateString("pt-BR", DATE_OPTS) : "—";
}

/** Data + hora: 29/05/2026 14:32 (vazio vira "—"). */
export function formatDateTime(
  value: string | Date | null | undefined,
): string {
  const d = parse(value);
  return d ? d.toLocaleString("pt-BR", DATE_TIME_OPTS) : "—";
}

/**
 * Duracao legivel entre dois instantes: "2min 14s", "1h 03min", "45s".
 * ``end`` ausente usa agora (duracao de execucao em andamento).
 * ``start`` ausente/invalido vira "—".
 */
export function formatDuration(
  start: string | Date | null | undefined,
  end?: string | Date | null,
): string {
  const s = parse(start);
  if (!s) return "—";
  const e = parse(end ?? null) ?? new Date();
  const totalSec = Math.max(0, Math.floor((e.getTime() - s.getTime()) / 1000));
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  if (hours > 0) {
    return `${hours}h ${String(minutes).padStart(2, "0")}min`;
  }
  if (minutes > 0) return `${minutes}min ${seconds}s`;
  return `${seconds}s`;
}
